import * as React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Container,
  ModalFooter,
  Button
} from "reactstrap"
import { FormattedMessage, intlShape } from "react-intl"
import {
  IUserProfileResponse,
  IUserProfile
} from "../../redux/sagaAuth/ISagaAuth"
import SagaAuthRedux from "../../redux/sagaAuth/sagaAuthRedux"
import { connect } from "react-redux"

class UserInfoModal extends React.Component<
  {
    visible: boolean
    onClose: () => void
    userInfo: IUserProfileResponse
    requestUpdateUserProfile: (userProfile: IUserProfile) => void
  },
  {
    id: string
    firstName: string
    lastName: string
    phoneNumber: string
    disable: boolean
  }
> {
  private static contextTypes = {
    intl: intlShape
  }

  constructor(props, context) {
    super(props)
    this.state = {
      id: this.props.userInfo && this.props.userInfo.userId,
      firstName: this.props.userInfo && this.props.userInfo.firstName,
      lastName: this.props.userInfo && this.props.userInfo.lastName,
      phoneNumber: this.props.userInfo && this.props.userInfo.mobilePhone,
      disable: true
    }
    this.context = context
  }

  public onPhoneChange(phoneNumber) {
    if (phoneNumber) {
      this.setState({ disable: false, phoneNumber })
    } else {
      this.setState({ disable: true, phoneNumber })
    }
  }

  public onUpdateUserProfile() {
    const { firstName, lastName, phoneNumber, id } = this.state
    const userInfo: IUserProfile = {
      phoneNumber,
      lastName,
      firstName,
      id
    }
    this.props.requestUpdateUserProfile(userInfo)
  }

  public render() {
    const { userInfo } = this.props
    const { phoneNumber, firstName, lastName, disable } = this.state
    return (
      <Modal
        isOpen={this.props.visible}
        size="md"
        toggle={() => this.props.onClose()}
      >
        <ModalHeader toggle={() => this.props.onClose()}>
          <FormattedMessage id="UserInfo" />
        </ModalHeader>
        <ModalBody>
          <Container>
            <Form>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="Email">
                      <FormattedMessage id="Email" />
                    </Label>
                    <Input
                      type="email"
                      name="email"
                      id="Email"
                      placeholder=""
                      value={userInfo && userInfo.email}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="FirstName">
                      <FormattedMessage id="FirstName" />
                    </Label>
                    <Input
                      type="text"
                      name="FirstName"
                      id="FirstName"
                      placeholder=""
                      value={firstName}
                      onChange={e =>
                        this.setState({ firstName: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="LastName">
                      <FormattedMessage id="LastName" />
                    </Label>
                    <Input
                      type="text"
                      name="LastName"
                      id="LastName"
                      placeholder=""
                      value={lastName}
                      onChange={e =>
                        this.setState({ lastName: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="PhoneNumber">
                      <FormattedMessage id="PhoneNumber" />
                    </Label>
                    <Input
                      type="text"
                      name="PhoneNumber"
                      id="PhoneNumber"
                      placeholder={this.context.intl.formatMessage({
                        id: "register.Validation.PhoneNumber.Required"
                      })}
                      value={phoneNumber}
                      onChange={e => this.onPhoneChange(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label style={{ color: "#d0021b" }}>
                      <FormattedMessage id="ShouldInputYouPhonenumber" />
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => this.onUpdateUserProfile()}
            disabled={disable}
          >
            <FormattedMessage id="Save" />
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestUpdateUserProfile: (userProfile: IUserProfile) =>
      dispatch(SagaAuthRedux.requestUpdateUserProfile(userProfile))
  }
}

export default connect(null, mapDispatchToProps)(UserInfoModal)



// WEBPACK FOOTER //
// ./src/components/accountModal/userInfoModal.tsx